import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  entityEntidadesProductivaAdapter,
  EntityEntidadesProductivaState
} from './entity-entidades-productiva.state';
import { selectCurrentEmpresa } from '../entity-mis-empresas/entity-current-empresa.selectors';
import { selectRolesPropios } from '../../roles/entity-roles/entity-roles.selectors';
import { selectAuthPersona } from '../../persona/entity-personas/entity-personas.selectors';

const { selectEntities, selectAll } =
  entityEntidadesProductivaAdapter.getSelectors();

export const getError = (state: EntityEntidadesProductivaState): any =>
  state.error;

export const getIsLoading = (state: EntityEntidadesProductivaState): boolean =>
  state.isLoading;

export const selectEntidadesProductivaState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.entidadesProductiva
);

export const selectAllEntidadesProductiva = createSelector(
  selectEntidadesProductivaState,
  selectAll
);

export const selectEntitiesEntidadesProductiva = createSelector(
  selectEntidadesProductivaState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectEntidadesProductivaError = createSelector(
  selectEntidadesProductivaState,
  getError
);

// MemoizedSelector<object,any>
export const selectEntidadesProductivaIsLoading = createSelector(
  selectEntidadesProductivaState,
  getIsLoading
);

// MemoizedSelector<object,any>
export const selectEntidadesProductivaFromCurrentEmpresa = createSelector(
  selectAllEntidadesProductiva,
  selectCurrentEmpresa,
  (entidadesProductiva, currentEmpresa) => {
    if (currentEmpresa) {
      return entidadesProductiva.filter(
        (entidadProductiva) => entidadProductiva.id === currentEmpresa.id
      );
    }
    return [];
  }
);

export const selectEntidadesProductivaRolesPropios = createSelector(
  selectAllEntidadesProductiva,
  selectRolesPropios,
  (entidadesProductivas, roles) => {
    const rolesActivos = roles.filter((r) => !r.fecha_baja);
    const rolesEntidadProductivaId = rolesActivos.map(
      (r) => r.entidad_productiva_id
    );
    if (entidadesProductivas) {
      return entidadesProductivas.filter((e) =>
        rolesEntidadProductivaId.includes(e.id)
      );
    }
    return [];
  }
);

export const selectEntidadesProductivaFromAuthPersona = createSelector(
  selectAllEntidadesProductiva,
  selectAuthPersona,
  (entidadesProductiva, authPersona) => {
    if (authPersona) {
      return entidadesProductiva.filter(
        (ep) => ep.usuario_creador_id === authPersona.id
      );
    }

    return [];
  }
);
